import React from "react";
import { Link } from "react-router-dom";
import SidebarNav from "../sidebar";

const AccessDenied = () => {
  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "60vh",
            }}
          >
            <h2 style={{ color: "#333", marginBottom: "16px" }}>
              Access Denied
            </h2>
            <p style={{ color: "#666", marginBottom: "24px", fontSize: "16px" }}>
              You do not have permission to access this page.
            </p>
            <Link
              to="/admin"
              className="btn btn-primary"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AccessDenied;
